<script>
import './styles.scss'

export default {
  name: 'header-central-interessado',
  props: {
    imageLogoSrc: {
      type: String,
      required: true,
      default: ''
    },
    descricaoLogo: {
      type: String,
      required: false,
      default: 'descrição da logo aqui...'
    },
    onLogoNavigateLink: {
      type: String,
      required: false
    }
  },
  methods: {
    onLogoNavigate () {
      if (this.onLogoNavigateLink && this.$router.app._route.fullPath !== this.onLogoNavigateLink) {
        this.$router.push(this.onLogoNavigateLink)
      }
    }
  }
}
</script>

<template>
  <el-card class="box-card">
    <div id="containerHeader">
      <div class="flex-aligned">
        <div id="logoContainer" @click="onLogoNavigate">
          <img :src="imageLogoSrc" />
        </div>
        <div id="LineSeparator"></div>
        <div>
          <p id="descricaoLogo">{{ descricaoLogo }}</p>
        </div>
      </div>
      <div>
        <slot name="RightButtons"></slot>
      </div>
    </div>
  </el-card>
</template>



// WEBPACK FOOTER //
// src/components(new)/layout/Headers/HeaderCentral/HeaderCentral.vue